export default {
  history: [],
  lastHistory: [],
};
